// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"d2991c3e","119":"52f42c24","289":"f3666b1e","360":"3449b581","442":"fce99edd","453":"e43bd730","479":"75aea92b","481":"d3b532e5","505":"3e20261c","516":"522a0abe","594":"a41e9b15","698":"eb352e35","716":"a1d41256","808":"b0777074","832":"7d3aba64","915":"8bc13a44"}[chunkId] + ".chunk.js";
};